import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  Aangifte, BerichtenService, BokkzAlgDataService,
  BokkzClient,
  BokkzIbDataService, ClientEntity,
  IncomeTaxEntity, SamenvoegRequest,
} from '@snelstart-ventures/fiscaal/domain-logic';
import {Observable, Subject, takeUntil} from 'rxjs';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {ButtonConfiguration, SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {CommonModule} from '@angular/common';
import {SharedUiLoadingModule} from '@snelstart/ui-loading';
import {ToastService} from "@snelstart/ui-toast";
import {Userpilot} from "userpilot";
import next = Userpilot.next;
import {error} from "ng-packagr/src/lib/utils/log";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-via',
  templateUrl: './via.component.html',
  styleUrls: ['./via.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiAlertModule,
    SharedUiLoadingModule,
    CommonModule
  ]
})
export class ViaComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  public sstRelationId: any;
  private destroy$ = new Subject<void>();
  public clientEntity = {} as ClientEntity;
  public incomeTaxEntity = {} as IncomeTaxEntity;
  public incomeTaxEntityPartner = {} as IncomeTaxEntity;
  public selectedYear : any;
  public heeftVia = false;
  public heeftViaPartner = false;
  public viaBeschikbaar = false;
  public partnerBoolean = false;
  public viaJson = {} as Aangifte;
  public viaJsonPartner = {} as Aangifte;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    { value: true, label: 'Ja' },
    { value: false, label: 'Nee' }
  ];

  constructor(private dataService: BokkzIbDataService,
              private dataAlgService: BokkzAlgDataService,
              private bokkzClient: BokkzClient,
              private berichtenService: BerichtenService,
              private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
    this.dataAlgService.selectedYear.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.selectedYear = value;
      if (value) {
        let date = (value + 1) + "-03-01"
        this.viaBeschikbaar = new Date(date) < new Date(new Date().toDateString())
      }
    })
    this.dataAlgService.client.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.clientEntity = value;
    })
    this.dataService.incomeTaxEntity.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (value.year) {
        this.incomeTaxEntity = value;
        if (value.viaXbrl) {
          this.heeftVia = true;
          this.getViaJson(value.viaXbrl, false);
        }
        else if (value.via) {
          this.heeftVia = true;
          this.viaJson = value.via;
        }
        if (value.aangifte?.partnerAangifte?.aangever?.bsn) {
          this.getPartnerEntity(value.aangifte.partnerAangifte.aangever.bsn, String(value.year));
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public configAangever = ButtonConfiguration.create({
    onClick: () =>
      new Observable((subscription) => {
        setTimeout(() => {
          subscription.next(true);
          subscription.complete();
          this.updateAangifteMetVia(false);
        }, 2000);
      })
  });

  public configPartner = ButtonConfiguration.create({
    onClick: () =>
      new Observable((subscription) => {
        setTimeout(() => {
          subscription.next(true);
          subscription.complete();
          this.updateAangifteMetVia(true);
        }, 2000);
      })
  });

  public getPartnerEntity(bsn: string, year:string) {
    this.bokkzClient.getIncomeTax(bsn, year).subscribe(value => {
      if (value.id) {
        this.incomeTaxEntityPartner = value;
        if (value.viaXbrl) {
          this.heeftViaPartner = true;
          this.getViaJson(value.viaXbrl, true);
        }
        else if (value.via) {
          this.heeftViaPartner = true;
          this.viaJson = value.via;
        }
      }
    })
  }

  public getViaJson(viaXbrlString: string, partner: boolean) {
    const ophaalResponse = {
      inhoud: btoa(viaXbrlString),
      berichtsoort: 'VIA'
    };
    this.berichtenService.converteerXbrlToJson(ophaalResponse).subscribe((data) => {
      if (partner) {
        this.viaJsonPartner = data;
      }
      else this.viaJson = data;
    });
  }

  public updateAangifteMetVia(partner: boolean) {
    const samenvoegRequest = {
      viaAangever: this.viaJson,
      viaPartner: partner ? this.viaJsonPartner : null,
      aangifte: this.incomeTaxEntity.aangifte
    } as SamenvoegRequest

    this.bokkzClient.getSamenvoegResponse(samenvoegRequest).subscribe((data) => {
      if (data.aangifteJaar) {
        this.incomeTaxEntity = {
          ...this.incomeTaxEntity,
          aangifte: data,
        }
        this.toastService.showSuccessMessage("De vooraf ingevulde gegevens zijn ingelezen in de aangifte.")
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
      }
      else {
        this.toastService.showErrorMessage("Er is een fout opgetreden bij het inlezen van de VIA gegevens. Probeer het later nog eens of neem contact op met onze klantenservice.")
      }
    })
  }
}
